import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { RouterProvider as TanStackRouterProvider } from '@tanstack/react-router';

import { ErrorFallback } from '@/components/error/error-fallback';
import { useAtlasClient } from '@/hooks/use-atlas-client';
import { useAuth } from '@/hooks/use-auth';
import { useGaiaClient } from '@/hooks/use-gaia-client';
import { router } from '@/singletons';
import { updateAgentCache } from '@/utils/agent-cache';

export const RouterProvider = () => {
  const { reset } = useQueryErrorResetBoundary();
  const auth = useAuth();
  const ldClient = useLDClient();
  const atlasClient = useAtlasClient();
  const gaiaClient = useGaiaClient();

  return (
    <TanStackRouterProvider
      router={router}
      context={{ auth, ldClient, atlasClient, gaiaClient, updateFacilityCache: updateAgentCache }}
      defaultErrorComponent={({ error }) => <ErrorFallback error={error} resetError={reset} />}
    />
  );
};
